// removed by extract-text-webpack-plugin
module.exports = {"container":"CheckboxGroup__container__2KKFO","btn":"CheckboxGroup__btn__6rC_B"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/UI/CheckboxGroup/CheckboxGroup.css
// module id = 541
// module chunks = 0